import { render, staticRenderFns } from "./PMChartsNode.vue?vue&type=template&id=1a460794&"
import script from "./PMChartsNode.vue?vue&type=script&lang=ts&"
export * from "./PMChartsNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports